import { useEffect, useState } from 'react';

export interface Countdown {
  secondsLeft: number;
  expired: boolean;
  label: string; // mm:ss
}

function compute(targetIso: string | null): number {
  if (!targetIso) return 0;
  const ms = new Date(targetIso).getTime() - Date.now();
  return Math.max(0, Math.floor(ms / 1000));
}

export function useCountdown(targetIso: string | null): Countdown {
  const [secondsLeft, setSecondsLeft] = useState(() => compute(targetIso));

  useEffect(() => {
    setSecondsLeft(compute(targetIso));
    if (!targetIso) return;
    const t = setInterval(() => setSecondsLeft(compute(targetIso)), 1000);
    return () => clearInterval(t);
  }, [targetIso]);

  const mm = String(Math.floor(secondsLeft / 60)).padStart(2, '0');
  const ss = String(secondsLeft % 60).padStart(2, '0');
  return { secondsLeft, expired: secondsLeft <= 0 && targetIso !== null, label: `${mm}:${ss}` };
}
